// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@charset \"UTF-8\";\n/* 字体 */\n/* Colors\n-------------------------- */\n/* 尺寸\n-------------------------- */\n.input-enter-select-popper {\n  display: none;\n}\n.demo-ruleFormty .main_pro_tips {\n  color: #556B81;\n}\n", ""]);
// Exports
module.exports = exports;
